import { render, staticRenderFns } from "./RoutesTab.vue?vue&type=template&id=a0215986&scoped=true&"
import script from "./RoutesTab.vue?vue&type=script&lang=js&"
export * from "./RoutesTab.vue?vue&type=script&lang=js&"
import style0 from "./RoutesTab.vue?vue&type=style&index=0&id=a0215986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0215986",
  null
  
)

export default component.exports
import {QForm,QTabs,QTab,QScrollArea,QTabPanels,QTabPanel,QBtn,QInput,QSelect,QIcon,QPopupProxy,QDate,QCardSection,QDialog,QCard,QSeparator,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QTabs,QTab,QScrollArea,QTabPanels,QTabPanel,QBtn,QInput,QSelect,QIcon,QPopupProxy,QDate,QCardSection,QDialog,QCard,QSeparator})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
